import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import { FormattedDate, FormattedTime } from 'react-intl'
import { Checkbox, Button } from '@arnsbogroup/react-voicearchive'
import BulkAssignProducerDialog from './components/BulkAssignProducerDialog'
import NiceModal from '@ebay/nice-modal-react'

const BacklogTaskWidget = ({widget}) => {
  const mounted = useRef(false);
  
  const [tasks, setTasks] = useState([]);
  const [bulkActions, setBulkActions] = useState(null);
  const [checkedTasks, setCheckedTasks] = useState([]);
  const [title, setTitle] = useState('');

  useEffect(() => {
    mounted.current = true;
    fetch(`supplierdashboard/${widget.widgetId}`)
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setTasks(data.data.tasks)
        setBulkActions(data.data.bulkActions);
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  const toggleAllTasks = () => {
    if (checkedTasks.length === tasks.length) {
      setCheckedTasks([])
    } else {
      setCheckedTasks(tasks.map((task) => {
        return task.uid
      }))
    }
  };

  const checkTask = (uid) => {
    if (checkedTasks.includes(uid)) {
      setCheckedTasks(checkedTasks.filter((taskUid) => taskUid !== uid));
    } else {
      setCheckedTasks([...checkedTasks, uid]);
    }
  };

  const getDeadline = (task) => {
    const value = new Date(task["deadline"] * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const taskDetails = (uid) => {
    reactHistory.push(`/task/${uid}`)
  };

  const getDeadlineStatus = (task) => {
    const diff = task['deadline'] - Math.floor(Date.now() / 1000);
    if(diff > 86400) {
      return <i className="block rounded-full w-2 h-2 bg-green-500" title="Deadline is not within the next 24 hours"></i>
    } else if (diff > 0) {
      return <i className="block rounded-full w-2 h-2 bg-yellow-500" title="Deadline is close!"></i>
    } else {
      return <i className="block rounded-full w-2 h-2 bg-red-600" title="Deadline has passed"></i>
    }
  }
  
  const bulkAssignProducer = () => {
    if (!checkedTasks.length) {
      toastr.error('Please select tasks')
      return
    }
    NiceModal.show(BulkAssignProducerDialog, {checkedTasks} )
  }

  const widget_id = `ID_${widget.widgetId}`;
  return (
    <li className="bg-white border m-4 shadow rounded border-gray-400" key={widget_id} id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />

      <div className="w-full text-xs">
        {bulkActions &&
          <div className="flex justify-between items-center px-4 py-2 border-b">
            <div className="w-4">
              <Checkbox
                checked={checkedTasks.length === tasks.length}
                onChange={() => {
                  toggleAllTasks()
                }}
              />
            </div>
            <div className="flex space-x-2">
              {bulkActions.map(({action, label}) => (
                <Button
                  size="sm"
                  onClick={() => eval(`${action}()`)}
                >
                  Bulk {label}
                </Button>
              ))}
            </div>
          </div>
        }
        {tasks.map((task) => (
          <div
            key={task.uid}
            className={`hover:bg-gray-200 flex border-b ${task['highlight'] ?? false ? 'bg-yellow-100' : ''}`}
            onClick={() => taskDetails(task.uid)}
            title={task['comments']}
          >
            {bulkActions &&
              <div className="shrink-0 px-4 py-2 w-4">
                <Checkbox
                  onClick={(e) => e.stopPropagation()}
                  checked={checkedTasks.some((taskId) => taskId == task.uid)}
                  onChange={() => {checkTask(task.uid)}}
                />
              </div>
            }
            <div className="shrink-0 px-4 py-2 w-28">

              {task?.cost_object?.cost} {task?.cost_object?.currency_iso} 
            </div>
            <div title={task.title} className="grow px-4 py-2 cursor-pointer hover:text-primary truncate">
                {task.title}
            </div>
            <div className="shrink-0 px-4 py-2 flex justify-between items-center space-x-4">
                <span>{getDeadline(task)}</span>
                <span className="w-1 inline-block ml-2 mr-1">
                    {task['comments'] ? <i className="text-yellow-500 fa fa-info"></i> : ''}
                </span>
                <span className="text-xs w-2 inline-block mr-1">
                    {getDeadlineStatus(task)}
                </span>
            </div>
          </div>
        ))}
      </div>
    </li>
  );

}

export default BacklogTaskWidget;
